import { render, staticRenderFns } from "./add-project-products.vue?vue&type=template&id=2ca50cf4&scoped=true&"
import script from "./add-project-products.vue?vue&type=script&lang=js&"
export * from "./add-project-products.vue?vue&type=script&lang=js&"
import style0 from "./add-project-products.vue?vue&type=style&index=0&id=2ca50cf4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca50cf4",
  null
  
)

export default component.exports